export default {"src":"/_next/static/media/0x641441c631e2f909700d2f41fd87f0aa6a6b4edb.e0a56871.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};